import axios from 'axios';

class DnaPaymentsService {

    async getPaymentFlowDetails(companyId, invoiceId, signature) {
        console.log("[DnaPaymentsService][getPaymentFlowDetails] Getting payment flow details for invoiceId ", invoiceId);
        return await axios.get(`/api/dnapayments/pay/${companyId}/${invoiceId}/${signature}`);
    }

    async getPaymentStatus(paymentReference) {
        console.log("[DnaPaymentsService][getPaymentStatus] Getting payment status for paymentReference ", paymentReference);
        return await axios.get(`/api/dnapayments/pay/status/${paymentReference}`);
    }
}

export default new DnaPaymentsService();
